import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

export const ContractItemWrapper = styled.div`
    background-color: ${getBaseTheme().colors.area.default.backgroundColor};
    font-size: ${getBaseTheme().texts.sizes.s.fontSize};
    line-height: ${getBaseTheme().texts.sizes.s.lineHeight};
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: ${getBaseTheme().spaces.insetSquish.s};

    :hover {
        cursor: pointer;
        background-color: ${getBaseTheme().colors.control.hover.backgroundColor};
    }

    :active {
        background-color: ${getBaseTheme().colors.control.active.backgroundColor};
    }
`;
